var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "generic" },
    [
      _c("h3", {
        staticClass: "generic__client",
        domProps: { textContent: _vm._s(_vm.item.client) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "generic__sector" }, [
        _vm.item.sector
          ? _c("span", {
              staticClass: "sector",
              domProps: { textContent: _vm._s(_vm.item.sector) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("DataList", {
        attrs: {
          items: [
            {
              title: "Deal Type",
              value: _vm.item.deal_type,
              icon: "deal",
              isSector: false,
            },
            {
              title: "MA Contract",
              value: _vm.item.ma_contact,
              icon: "value",
              isSector: false,
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "generic__description",
        domProps: { textContent: _vm._s(_vm.item.business_description) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }